// Collection slugs that were retired during the catalogue cleanup but are still
// present in Google's index (Search Console shows /collections/human-body-glitches
// with the site's best measured CTR, yet the URL 404s). A 404 throws away the
// ranking and the visitor; a permanent redirect keeps both and lets Google
// transfer the signal to the surviving collection.
//
// Anything not listed here falls back to /collections, which is always valid.
export const RETIRED_COLLECTIONS: Record<string, string> = {
  "human-body-glitches": "inside-your-body",
  "the-body-betrays-you": "inside-your-body",
  "body-horror": "inside-your-body",
  "deep-sea-nightmares": "ocean-deep",
  "the-deep-blue": "ocean-deep",
  "ocean-mysteries": "ocean-deep",
  "deadly-creatures": "things-that-can-kill-you",
  "killer-animals": "things-that-can-kill-you",
  "venomous-things": "things-that-can-kill-you",
  "prehistoric-earth": "natural-wonders",
  "ancient-world": "natural-wonders",
  "space-oddities": "out-there",
  "the-universe-files": "out-there",
  "weird-weather": "natural-wonders",
  "extreme-earth": "natural-wonders",
  "brain-files": "head-stuff",
  "your-senses": "head-stuff",
  "impossible-animals": "animals-that-shouldnt-exist",
  "tiny-terrors": "the-tiny-and-terrifying",
  "plant-power": "natural-wonders",
  "apex-predators": "things-that-can-kill-you",
  "venom-and-poison": "things-that-can-kill-you",
  "survival-superpowers": "animals-that-shouldnt-exist",
  "plants-strike-back": "natural-wonders",
  "weather-gone-wrong": "natural-wonders",
  "extremes-on-earth": "natural-wonders",
  "frozen-worlds": "natural-wonders",
  "ancient-earth-files": "natural-wonders",
  "the-human-brain-files": "head-stuff",
  "blood-and-guts": "inside-your-body",
  "senses-redefined": "head-stuff",
  "space-is-trying-to-kill-you": "out-there",
  "cosmic-mysteries": "out-there",
  "worlds-stranger-than-science-fiction": "out-there",
  "light-and-color": "everyday-impossible",
  "nature-solved-it-first": "animals-with-a-plan",
  "everyday-tech-decoded": "everyday-impossible",
  "sound-and-silence": "everyday-impossible",
  "ancient-earth-": "natural-wonders",
  "ancient-earth": "natural-wonders",
};

/** Live collection slug a retired URL should hand its traffic to, if any. */
export function retiredCollectionTarget(slug: string): string | null {
  return RETIRED_COLLECTIONS[slug] ?? null;
}
